import { isFulfilled, isPending, isRejected, isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

import { startLoader, stopLoader } from '../../features/ui/uiSlice';

let numberOfCalls = 0;
let timeout;

const showAppSpinner = (store) => {
  const dispatch = store.dispatch;
  if (numberOfCalls === 0) {
    dispatch(startLoader());
  }
  clearTimeout(timeout);
  numberOfCalls++;
};

const hideAppSpinner = (store) => {
  const dispatch = store.dispatch;
  numberOfCalls--;
  if (numberOfCalls === 0) {
    // Adding timeout to reduce loader jumping between calls.
    timeout = setTimeout(() => dispatch(stopLoader()), 500);
  }
};

export const appSpinnerMiddleware: Middleware = (store) => (next) => (action) => {
  if (isPending(action)) {
    showAppSpinner(store);
  }
  if (isFulfilled(action) || isRejected(action) || isRejectedWithValue(action)) {
    hideAppSpinner(store);
  }
  return next(action);
};
